import { ScheduleItem } from '@types';

type SegmentProps = {
  isANF: boolean;
  anf: unknown[] | undefined; // fix type to correct one
  isLive: boolean;
  schedule: ScheduleItem[];
  seriestitle: string;
};

export const getSegmentDisplayName = ({ isANF, anf, isLive, schedule, seriestitle }: SegmentProps) => {
  let segment_display_name = '';

  if (isANF) {
    segment_display_name = anf?.find(anfItem => anfItem?.selected)?.title;
  } else if (isLive) {
    segment_display_name = schedule?.find(channel => channel.selected)?.program[0]?.program_title || '';
  } else {
    segment_display_name = seriestitle;
  }
  return segment_display_name;
};
